import { ChildProperty, compile as baseTemplateComplier, setValue, Internationalization, isUndefined, closest } from '@syncfusion/ej2-base';
import { extend as baseExtend, isNullOrUndefined, getValue, classList } from '@syncfusion/ej2-base';
import { setStyleAttribute, addClass, attributes, remove, createElement, removeClass } from '@syncfusion/ej2-base';
import { isObject, isBlazor, Browser, select, selectAll } from '@syncfusion/ej2-base';
import { DataUtil, Query, DataManager, Predicate, UrlAdaptor, Deferred } from '@syncfusion/ej2-data';
import { Column } from '../models/column';
import { calculateRelativeBasedPosition } from '@syncfusion/ej2-popups';
import { Print } from '../actions/print';
import * as literals from '../base/string-literals'; //https://typescript.codeplex.com/discussions/401501

/**
 * Function to check whether target object implement specific interface
 * @param  {Object} target
 * @param  {string} checkFor
 * @returns no
 * @hidden
 */

export function doesImplementInterface(target, checkFor) {
  /* tslint:disable:no-any */
  return target.prototype && checkFor in target.prototype;
}
/**
 * Function to get value from provided data
 * @param  {string} field
 * @param  {Object} data
 * @param  {IColumn} column
 * @hidden
 */

export function valueAccessor(field, data, column) {
  return isNullOrUndefined(field) || field === '' ? '' : DataUtil.getObject(field, data);
}
/**
 * Defines the method used to apply custom header cell values from external function and display this on each header cell rendered.
 * @param  {string} field
 * @param  {IColumn} column
 * @hidden
 */

export function headerValueAccessor(field, column) {
  return isNullOrUndefined(field) || field === '' ? '' : DataUtil.getObject(field, column);
}
/**
 * The function used to update Dom using requestAnimationFrame.
 * @param  {Function} fn - Function that contains the actual action
 * @return {Promise<T>}
 * @hidden
 */

export function getUpdateUsingRaf(updateFunction, callBack) {
  requestAnimationFrame(function () {
    try {
      callBack(null, updateFunction());
    } catch (e) {
      callBack(e);
    }
  });
}
/**
 * @hidden
 */

export function isExportColumns(exportProperties) {
  return !isNullOrUndefined(exportProperties) && !isNullOrUndefined(exportProperties.columns) && exportProperties.columns.length > 0;
}
/**
 * @hidden
 */

export function updateColumnTypeForExportColumns(exportProperties, gObj) {
  var exportColumns = exportProperties.columns;
  var gridColumns = gObj.columns;

  for (var i = 0; i < exportColumns.length; i++) {
    if (gridColumns.length - 1 >= i) {
      if (gridColumns[i].columns) {
        for (var j = 0; j < gridColumns[i].columns.length; j++) {
          exportColumns[i].columns[j].type = gridColumns[i].columns[j].type;
        }
      } else {
        exportColumns[i].type = gridColumns[i].type;
      }
    }
  }
}
/**
 * @hidden
 */

export function updatecloneRow(grid) {
  var nRows = [];
  var actualRows = grid.vRows;

  for (var i = 0; i < actualRows.length; i++) {
    if (actualRows[i].isDataRow) {
      nRows.push(actualRows[i]);
    } else if (!actualRows[i].isDataRow) {
      nRows.push(actualRows[i]);

      if (!actualRows[i].isExpand && actualRows[i].isCaptionRow) {
        i += getCollapsedRowsCount(actualRows[i], grid);
      }
    }
  }

  grid.vcRows = nRows;
}
/**
 * @hidden
 */

var count = 0;
export function getCollapsedRowsCount(val, grid) {
  count = 0;
  var gSummary = 'gSummary';
  var total = 'count';
  var gLen = grid.groupSettings.columns.length;
  var records = 'records';
  var items = 'items';
  var value = val[gSummary];
  var dataRowCnt = 0;
  var agrCnt = 'aggregatesCount';

  if (value === val.data[total]) {
    if (grid.groupSettings.columns.length && !isNullOrUndefined(val[agrCnt]) && val[agrCnt]) {
      if (grid.groupSettings.columns.length !== 1) {
        count += val.indent !== 0 && value < 2 ? val[gSummary] * (gLen - val.indent + (gLen - val.indent) * val[agrCnt]) : val[gSummary] * (gLen - val.indent + (gLen - val.indent - 1) * val[agrCnt]) + val[agrCnt];
      } else if (grid.groupSettings.columns.length === 1) {
        count += val[gSummary] * (gLen - val.indent) + val[agrCnt];
      }
    } else if (grid.groupSettings.columns.length) {
      if (grid.groupSettings.columns.length !== 1) {
        count += val[gSummary] * (grid.groupSettings.columns.length - val.indent);
      } else {
        count += val[gSummary];
      }
    }

    return count;
  } else {
    for (var i = 0, len = val.data[items].length; i < len; i++) {
      var gLevel = val.data[items][i];
      count += gLevel[items].length + (gLen !== grid.columns.length && !isNullOrUndefined(gLevel[items][records]) ? gLevel[items][records].length : 0);
      dataRowCnt += !isNullOrUndefined(gLevel[items][records]) && !isNullOrUndefined(val[agrCnt]) ? gLevel[items][records].length : gLevel[items].length;

      if (gLevel[items].GroupGuid && gLevel[items].childLevels !== 0) {
        recursive(gLevel);
      }
    }

    count += val.data[items].length;

    if (!isNullOrUndefined(val[agrCnt])) {
      if (val[agrCnt] && count && dataRowCnt !== 0) {
        count += (count - dataRowCnt) * val[agrCnt] + val[agrCnt];
      }
    }
  }

  return count;
}
/**
 * @hidden
 */

export function recursive(row) {
  var items = 'items';
  var rCount = 'count';

  for (var j = 0, length_1 = row[items].length; j < length_1; j++) {
    var nLevel = row[items][j];
    count += nLevel[rCount];

    if (nLevel[items].childLevels !== 0) {
      recursive(nLevel);
    }
  }
}
/**
 * @hidden
 */

export function iterateArrayOrObject(collection, predicate) {
  var result = [];

  for (var i = 0, len = collection.length; i < len; i++) {
    var pred = predicate(collection[i], i);

    if (!isNullOrUndefined(pred)) {
      result.push(pred);
    }
  }

  return result;
}
/** @hidden */

export function iterateExtend(array) {
  var obj = [];

  for (var i = 0; i < array.length; i++) {
    obj.push(baseExtend({}, getActualProperties(array[i]), {}, true));
  }

  return obj;
}
/** @hidden */

export function templateCompiler(template) {
  if (template) {
    var e = void 0;

    try {
      if (document.querySelectorAll(template).length) {
        return baseTemplateComplier(document.querySelector(template).innerHTML.trim());
      }
    } catch (e) {
      return baseTemplateComplier(template);
    }
  }

  return undefined;
}
/** @hidden */

export function setStyleAndAttributes(node, customAttributes) {
  var copyAttr = {};
  var literals = ['style', 'class']; //Dont touch the original object - make a copy

  baseExtend(copyAttr, customAttributes, {});

  if ('style' in copyAttr) {
    setStyleAttribute(node, copyAttr[literals[0]]);
    delete copyAttr[literals[0]];
  }

  if ('class' in copyAttr) {
    addClass([node], copyAttr[literals[1]]);
    delete copyAttr[literals[1]];
  }

  attributes(node, copyAttr);
}
/** @hidden */

export function extend(copied, first, second, exclude) {
  var moved = baseExtend(copied, first, second);
  var values = Object.keys(moved);

  for (var i = 0; i < values.length; i++) {
    if (exclude && exclude.indexOf(values[i]) !== -1) {
      delete moved[values[i]];
    }
  }

  return moved;
}
/** @hidden */

export function setColumnIndex(columnModel, ind) {
  if (ind === void 0) {
    ind = 0;
  }

  for (var i = 0, len = columnModel.length; i < len; i++) {
    if (columnModel[i].columns) {
      columnModel[i].index = isNullOrUndefined(columnModel[i].index) ? ind : columnModel[i].index;
      ind++;
      ind = setColumnIndex(columnModel[i].columns, ind);
    } else {
      columnModel[i].index = isNullOrUndefined(columnModel[i].index) ? ind : columnModel[i].index;
      ind++;
    }
  }

  return ind;
}
/** @hidden */

export function prepareColumns(columns, autoWidth, gObj) {
  for (var c = 0, len = columns.length; c < len; c++) {
    var column = void 0;

    if (typeof columns[c] === 'string') {
      column = new Column({
        field: columns[c]
      }, gObj);
    } else if (!(columns[c] instanceof Column)) {
      if (!columns[c].columns) {
        column = new Column(columns[c], gObj);
      } else {
        columns[c].columns = prepareColumns(columns[c].columns, null, gObj);
        column = new Column(columns[c], gObj);
      }
    } else {
      column = columns[c];
    }

    if (column.type && column.type.toLowerCase() === 'checkbox') {
      column.allowReordering = false;
    }

    column.headerText = isNullOrUndefined(column.headerText) ? column.foreignKeyValue || column.field || '' : column.headerText;
    column.foreignKeyField = column.foreignKeyField || column.field;
    column.valueAccessor = (typeof column.valueAccessor === 'string' ? getValue(column.valueAccessor, window) : column.valueAccessor) || valueAccessor;
    column.width = autoWidth && isNullOrUndefined(column.width) ? 200 : column.width;

    if (isNullOrUndefined(column.visible)) {
      column.visible = true;
    }

    columns[c] = column;
  }

  return columns;
}
/** @hidden */

export function setCssInGridPopUp(popUp, e, className) {
  var popUpSpan = popUp.querySelector('span');
  var position = popUp.parentElement.getBoundingClientRect();
  var targetPosition = e.target.getBoundingClientRect();
  var isBottomTail;
  popUpSpan.className = className;
  popUp.style.display = '';
  isBottomTail = (isNullOrUndefined(e.clientY) ? e.changedTouches[0].clientY : e.clientY) > popUp.offsetHeight + 10;
  popUp.style.top = targetPosition.top - position.top + (isBottomTail ? -(popUp.offsetHeight + 10) : popUp.offsetHeight + 10) + 'px'; //10px for tail element

  popUp.style.left = getPopupLeftPosition(popUp, e, targetPosition, position.left) + 'px';

  if (isBottomTail) {
    popUp.querySelector('.e-downtail').style.display = '';
    popUp.querySelector('.e-uptail').style.display = 'none';
  } else {
    popUp.querySelector('.e-downtail').style.display = 'none';
    popUp.querySelector('.e-uptail').style.display = '';
  }
}
/** @hidden */

function getPopupLeftPosition(popup, e, targetPosition, left) {
  var width = popup.offsetWidth / 2;
  var x = getPosition(e).x;

  if (x - targetPosition.left < width) {
    return targetPosition.left - left;
  } else if (targetPosition.right - x < width) {
    return targetPosition.right - left - width * 2;
  } else {
    return x - left - width;
  }
}
/** @hidden */


export function getActualProperties(obj) {
  if (obj instanceof ChildProperty) {
    return getValue('properties', obj);
  } else {
    return obj;
  }
}
/** @hidden */

export function parentsUntil(elem, selector, isID) {
  var parent = elem;

  while (parent) {
    if (isID ? parent.id === selector : parent.classList.contains(selector)) {
      break;
    }

    parent = parent.parentElement;
  }

  return parent;
}
/** @hidden */

export function getElementIndex(element, elements) {
  var index = -1;

  for (var i = 0, len = elements.length; i < len; i++) {
    if (elements[i].isEqualNode(element)) {
      index = i;
      break;
    }
  }

  return index;
}
/** @hidden */

export function inArray(value, collection) {
  for (var i = 0, len = collection.length; i < len; i++) {
    if (collection[i] === value) {
      return i;
    }
  }

  return -1;
}
/** @hidden */

export function getActualPropFromColl(collection) {
  var coll = [];

  for (var i = 0, len = collection.length; i < len; i++) {
    if (collection[i].hasOwnProperty('properties')) {
      coll.push(collection[i].properties);
    } else {
      coll.push(collection[i]);
    }
  }

  return coll;
}
/** @hidden */

export function removeElement(target, selector) {
  var elements = [].slice.call(target.querySelectorAll(selector));

  for (var i = 0; i < elements.length; i++) {
    remove(elements[i]);
  }
}
/** @hidden */

export function getPosition(e) {
  var position = {};
  position.x = isNullOrUndefined(e.clientX) ? e.changedTouches[0].clientX : e.clientX;
  position.y = isNullOrUndefined(e.clientY) ? e.changedTouches[0].clientY : e.clientY;
  return position;
}
var uid = 0;
/** @hidden */

export function getUid(prefix) {
  return prefix + uid++;
}
/** @hidden */

export function appendChildren(elem, children) {
  for (var i = 0, len = children.length; i < len; i++) {
    if (len === children.length) {
      elem.appendChild(children[i]);
    } else {
      elem.appendChild(children[0]);
    }
  }

  return elem;
}
/** @hidden */

export function parents(elem, selector, isID) {
  var parent = elem;
  var parents = [];

  while (parent) {
    if (isID ? parent.id === selector : parent.classList.contains(selector)) {
      parents.push(parent);
    }

    parent = parent.parentElement;
  }

  return parents;
}
/** @hidden */

export function calculateAggregate(type, data, column, context) {
  if (type === 'Custom') {
    var temp = column.customAggregate;

    if (typeof temp === 'string') {
      temp = getValue(temp, window);
    }

    return temp ? temp.call(context, data, column) : '';
  }

  return column.field in data || data instanceof Array ? DataUtil.aggregates[type.toLowerCase()](data, column.field) : null;
}
/** @hidden */

var scrollWidth = null;
/** @hidden */

export function getScrollBarWidth() {
  if (scrollWidth !== null) {
    return scrollWidth;
  }

  var divNode = document.createElement('div');
  var value = 0;
  divNode.style.cssText = 'width:100px;height: 100px;overflow: scroll;position: absolute;top: -9999px;';
  document.body.appendChild(divNode);
  value = divNode.offsetWidth - divNode.clientWidth | 0;
  document.body.removeChild(divNode);
  return scrollWidth = value;
}
/** @hidden */

var rowHeight;
/** @hidden */

export function getRowHeight(element) {
  if (rowHeight !== undefined) {
    return rowHeight;
  }

  var table = createElement('table', {
    className: literals.table,
    styles: 'visibility: hidden'
  });
  table.innerHTML = '<tr><td class="e-rowcell">A<td></tr>';
  element.appendChild(table);
  var rect = table.querySelector('td').getBoundingClientRect();
  element.removeChild(table);
  rowHeight = Math.ceil(rect.height);
  return rowHeight;
}
/** @hidden */

var actualRowHeight;
/** @hidden */

export function getActualRowHeight(element) {
  if (actualRowHeight !== undefined) {
    return rowHeight;
  }

  var table = createElement('table', {
    className: literals.table,
    styles: 'visibility: hidden'
  });
  table.innerHTML = '<tr><td class="e-rowcell">A<td></tr>';
  element.appendChild(table);
  var rect = table.querySelector('tr').getBoundingClientRect();
  element.removeChild(table);
  return rect.height;
}
/** @hidden */

export function isComplexField(field) {
  return field.split('.').length > 1;
}
/** @hidden */

export function getComplexFieldID(field) {
  if (field === void 0) {
    field = '';
  }

  return field.replace(/\./g, '___');
}
/** @hidden */

export function setComplexFieldID(field) {
  if (field === void 0) {
    field = '';
  }

  return field.replace(/___/g, '.');
}
/** @hidden */

export function isEditable(col, type, elem) {
  var row = parentsUntil(elem, literals.row);
  var isOldRow = !row ? true : row && !row.classList.contains('e-insertedrow');

  if (type === 'beginEdit' && isOldRow) {
    if (col.isIdentity || col.isPrimaryKey || !col.allowEditing) {
      return false;
    }

    return true;
  } else if (type === 'add' && col.isIdentity) {
    return false;
  } else {
    if (isOldRow && !col.allowEditing && !col.isIdentity && !col.isPrimaryKey) {
      return false;
    }

    return true;
  }
}
/** @hidden */

export function isActionPrevent(inst) {
  var dlg = select('#' + inst.element.id + 'EditConfirm', inst.element);
  return inst.editSettings.mode === 'Batch' && selectAll('.e-updatedtd', inst.element).length && inst.editSettings.showConfirmDialog && (dlg ? dlg.classList.contains('e-popup-close') : true);
}
/** @hidden */

export function wrap(elem, action) {
  var clName = 'e-wrap';
  elem = elem instanceof Array ? elem : [elem];

  for (var i = 0; i < elem.length; i++) {
    action ? elem[i].classList.add(clName) : elem[i].classList.remove(clName);
  }
}
/** @hidden */

export function setFormatter(serviceLocator, column, isServerRendered) {
  var fmtr = serviceLocator.getService('valueFormatter');
  var format = 'format';
  var args;

  if (column.type === 'date' || column.type === 'datetime') {
    args = {
      type: column.type,
      skeleton: column.format
    };

    if (isBlazor() && isServerRendered) {
      var isServer = 'isServerRendered';
      args[isServer] = isServerRendered;
    }

    if (typeof column.format === 'string' && column.format !== 'yMd') {
      args[format] = column.format;
    }
  }

  switch (column.type) {
    case 'date':
      column.setFormatter(fmtr.getFormatFunction(args));
      column.setParser(fmtr.getParserFunction(args));
      break;

    case 'datetime':
      column.setFormatter(fmtr.getFormatFunction(args));
      column.setParser(fmtr.getParserFunction(args));
      break;

    case 'number':
      column.setFormatter(fmtr.getFormatFunction({
        format: column.format
      }));
      column.setParser(fmtr.getParserFunction({
        format: column.format
      }));
      break;
  }
}
/** @hidden */

export function addRemoveActiveClasses(cells, add) {
  var args = [];

  for (var _i = 2; _i < arguments.length; _i++) {
    args[_i - 2] = arguments[_i];
  }

  for (var i = 0, len = cells.length; i < len; i++) {
    if (add) {
      classList(cells[i], args.slice(), []);
      cells[i].setAttribute('aria-selected', 'true');
    } else {
      classList(cells[i], [], args.slice());
      cells[i].removeAttribute('aria-selected');
    }
  }
}
/** @hidden */

export function distinctStringValues(result) {
  var temp = {};
  var res = [];

  for (var i = 0; i < result.length; i++) {
    if (!(result[i] in temp)) {
      res.push(result[i].toString());
      temp[result[i]] = 1;
    }
  }

  return res;
}
/** @hidden */

export function getFilterMenuPostion(target, dialogObj, grid) {
  var elementVisible = dialogObj.element.style.display;
  dialogObj.element.style.display = 'block';
  var dlgWidth = dialogObj.width;
  var newpos;
  newpos = calculateRelativeBasedPosition(target, dialogObj.element);
  dialogObj.element.style.display = elementVisible;
  dialogObj.element.style.top = newpos.top + target.getBoundingClientRect().height - 5 + 'px';
  var leftPos = newpos.left - dlgWidth + target.clientWidth;

  if (leftPos < 1) {
    dialogObj.element.style.left = dlgWidth + leftPos - 16 + 'px'; // right calculation
  } else {
    dialogObj.element.style.left = leftPos + -4 + 'px';
  }
}
/** @hidden */

export function getZIndexCalcualtion(args, dialogObj) {
  args.popup.element.style.zIndex = (dialogObj.zIndex + 1).toString();
}
/** @hidden */

export function toogleCheckbox(elem) {
  var span = elem.querySelector('.e-frame');
  var input = span.previousSibling;

  if (span.classList.contains('e-check')) {
    input.checked = false;
    classList(span, ['e-uncheck'], ['e-check']);
  } else {
    input.checked = true;
    classList(span, ['e-check'], ['e-uncheck']);
  }
}
/** @hidden */

export function setChecked(elem, checked) {
  elem.checked = checked;
}
/** @hidden */

export function createCboxWithWrap(uid, elem, className) {
  var div = createElement('div', {
    className: className
  });
  div.appendChild(elem);
  div.setAttribute('uid', uid);
  return div;
}
/** @hidden */

export function removeAddCboxClasses(elem, checked) {
  removeClass([elem], ['e-check', 'e-stop', 'e-uncheck']);

  if (checked) {
    elem.classList.add('e-check');
  } else {
    elem.classList.add('e-uncheck');
  }
}
/**
 * Refresh the Row model's foreign data.
 * @param row - Grid Row model object.
 * @param columns - Foreign columns array.
 * @param data - Updated Row data.
 * @hidden
 */

export function refreshForeignData(row, columns, data) {
  for (var i = 0; i < columns.length; i++) {
    setValue(columns[i].field, getForeignData(columns[i], data), row.foreignKeyData);
  }

  var cells = row.cells;

  for (var i = 0; i < cells.length; i++) {
    if (cells[i].isForeignKey) {
      setValue('foreignKeyData', getValue(cells[i].column.field, row.foreignKeyData), cells[i]);
    }
  }
}
/**
 * Get the foreign data for the corresponding cell value.
 * @param column - Foreign Key column
 * @param data - Row data.
 * @param lValue - cell value.
 * @param foreignData - foreign data source.
 * @hidden
 */

export function getForeignData(column, data, lValue, foreignKeyData) {
  var fField = column.foreignKeyField;
  var key = !isNullOrUndefined(lValue) ? lValue : valueAccessor(column.field, data, column);
  key = isNullOrUndefined(key) ? '' : key;
  var query = new Query();
  var fdata = foreignKeyData || (column.dataSource instanceof DataManager && column.dataSource.dataSource.json.length ? column.dataSource.dataSource.json : column.columnData);

  if (key.getDay) {
    query.where(getDatePredicate({
      field: fField,
      operator: 'equal',
      value: key,
      matchCase: false
    }));
  } else {
    query.where(fField, '==', key, false);
  }

  return new DataManager(fdata).executeLocal(query);
}
/**
 * To use to get the column's object by the foreign key value.
 * @param foreignKeyValue - Defines ForeignKeyValue.
 * @param columns - Array of column object.
 * @hidden
 */

export function getColumnByForeignKeyValue(foreignKeyValue, columns) {
  var column;
  return columns.some(function (col) {
    column = col;
    return col.foreignKeyValue === foreignKeyValue;
  }) && column;
}
/**
 * @hidden
 * @param filterObject - Defines predicate model object
 */

export function getDatePredicate(filterObject, type) {
  var datePredicate;
  var prevDate;
  var nextDate;
  var prevObj = baseExtend({}, getActualProperties(filterObject));
  var nextObj = baseExtend({}, getActualProperties(filterObject));

  if (isNullOrUndefined(filterObject.value)) {
    datePredicate = new Predicate(prevObj.field, prevObj.operator, prevObj.value, false);
    return datePredicate;
  }

  var value = new Date(filterObject.value);

  if (filterObject.operator === 'equal' || filterObject.operator === 'notequal') {
    if (type === 'datetime') {
      prevDate = new Date(value.setSeconds(value.getSeconds() - 1));
      nextDate = new Date(value.setSeconds(value.getSeconds() + 2));
      filterObject.value = new Date(value.setSeconds(nextDate.getSeconds() - 1));
    } else {
      prevDate = new Date(value.setHours(0) - 1);
      nextDate = new Date(value.setHours(24));
    }

    prevObj.value = prevDate;
    nextObj.value = nextDate;

    if (filterObject.operator === 'equal') {
      prevObj.operator = 'greaterthan';
      nextObj.operator = 'lessthan';
    } else if (filterObject.operator === 'notequal') {
      prevObj.operator = 'lessthanorequal';
      nextObj.operator = 'greaterthanorequal';
    }

    var predicateSt = new Predicate(prevObj.field, prevObj.operator, prevObj.value, false);
    var predicateEnd = new Predicate(nextObj.field, nextObj.operator, nextObj.value, false);
    datePredicate = filterObject.operator === 'equal' ? predicateSt.and(predicateEnd) : predicateSt.or(predicateEnd);
  } else {
    if (typeof prevObj.value === 'string') {
      prevObj.value = new Date(prevObj.value);
    }

    var predicates = new Predicate(prevObj.field, prevObj.operator, prevObj.value, false);
    datePredicate = predicates;
  }

  if (filterObject.setProperties) {
    filterObject.setProperties({
      ejpredicate: datePredicate
    }, true);
  } else {
    filterObject.ejpredicate = datePredicate;
  }

  return datePredicate;
}
/**
 * @hidden
 */

export function renderMovable(ele, frzCols, gObj) {
  frzCols = frzCols && gObj && gObj.isRowDragable() ? frzCols + 1 : frzCols;
  var mEle = ele.cloneNode(true);

  for (var i = 0; i < frzCols; i++) {
    mEle.removeChild(mEle.children[0]);
  }

  for (var i = frzCols, len = ele.childElementCount; i < len; i++) {
    ele.removeChild(ele.children[ele.childElementCount - 1]);
  }

  return mEle;
}
/**
 * @hidden
 */

export function isGroupAdaptive(grid) {
  return grid.enableVirtualization && grid.groupSettings.columns.length > 0 && grid.isVirtualAdaptive;
}
/**
 * @hidden
 */

export function getObject(field, object) {
  if (field === void 0) {
    field = '';
  }

  if (field) {
    var value = object;
    var splits = field.split('.');

    for (var i = 0; i < splits.length && !isNullOrUndefined(value); i++) {
      value = value[splits[i]];
    }

    return value;
  }
}
/**
 * @hidden
 */

export function getCustomDateFormat(format, colType) {
  var intl = new Internationalization();
  var formatvalue;
  var formatter = 'format';
  var type = 'type';

  if (colType === 'date') {
    formatvalue = typeof format === 'object' ? intl.getDatePattern({
      type: format[type] ? format[type] : 'date',
      format: format[formatter]
    }, false) : isBlazor() ? intl.getDatePattern({
      type: 'dateTime',
      format: format
    }, false) : intl.getDatePattern({
      type: 'dateTime',
      skeleton: format
    }, false);
  } else {
    formatvalue = typeof format === 'object' ? intl.getDatePattern({
      type: format[type] ? format[type] : 'dateTime',
      format: format[formatter]
    }, false) : isBlazor() ? intl.getDatePattern({
      type: 'dateTime',
      format: format
    }, false) : intl.getDatePattern({
      type: 'dateTime',
      skeleton: format
    }, false);
  }

  return formatvalue;
}
/**
 * @hidden
 */

export function getExpandedState(gObj, hierarchyPrintMode) {
  var rows = gObj.getRowsObject();
  var obj = {};

  for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
    var row = rows_1[_i];

    if (row.isExpand && !row.isDetailRow) {
      var index = gObj.allowPaging && gObj.printMode === 'AllPages' ? row.index + gObj.pageSettings.currentPage * gObj.pageSettings.pageSize - gObj.pageSettings.pageSize : row.index;
      obj[index] = {};
      obj[index].isExpand = true;
      obj[index].gridModel = getPrintGridModel(row.childGrid, hierarchyPrintMode);
      obj[index].gridModel.query = gObj.childGrid.query;
    }
  }

  return obj;
}
/**
 * @hidden
 */

export function getPrintGridModel(gObj, hierarchyPrintMode) {
  if (hierarchyPrintMode === void 0) {
    hierarchyPrintMode = 'Expanded';
  }

  var printGridModel = {};

  if (!gObj) {
    return printGridModel;
  }

  var isFrozen = gObj.isFrozenGrid() && !gObj.getFrozenColumns();

  for (var _i = 0, _a = Print.printGridProp; _i < _a.length; _i++) {
    var key = _a[_i];

    if (key === 'columns') {
      printGridModel[key] = getActualPropFromColl(isFrozen ? gObj.getColumns() : gObj[key]);
    } else if (key === 'allowPaging') {
      printGridModel[key] = gObj.printMode === 'CurrentPage';
    } else {
      printGridModel[key] = getActualProperties(gObj[key]);
    }
  }

  printGridModel['enableHover'] = false;

  if (gObj.childGrid && hierarchyPrintMode !== 'None') {
    printGridModel.expandedRows = getExpandedState(gObj, hierarchyPrintMode);
  }

  return printGridModel;
}
/**
 * @hidden
 */

export function extendObjWithFn(copied, first, second, deep) {
  var res = copied || {};
  var len = arguments.length;

  if (deep) {
    len = len - 1;
  }

  for (var i = 1; i < len; i++) {
    if (!arguments[i]) {
      continue;
    }

    var obj1 = arguments[i];
    var keys = Object.keys(Object.getPrototypeOf(obj1)).length ? Object.keys(obj1).concat(getPrototypesOfObj(obj1)) : Object.keys(obj1);

    for (var i_1 = 0; i_1 < keys.length; i_1++) {
      var source = res[keys[i_1]];
      var cpy = obj1[keys[i_1]];
      var cln = void 0;

      if (deep && (isObject(cpy) || Array.isArray(cpy))) {
        if (isObject(cpy)) {
          cln = source ? source : {};
          res[keys[i_1]] = baseExtend({}, cln, cpy, deep);
        } else {
          cln = source ? source : [];
          res[keys[i_1]] = baseExtend([], cln, cpy, deep);
        }
      } else {
        res[keys[i_1]] = cpy;
      }
    }
  }

  return res;
}
/**
 * @hidden
 */

function getPrototypesOfObj(obj) {
  var keys = [];

  while (Object.getPrototypeOf(obj) && Object.keys(Object.getPrototypeOf(obj)).length) {
    keys = keys.concat(Object.keys(Object.getPrototypeOf(obj)));
    obj = Object.getPrototypeOf(obj);
  }

  return keys;
}
/**
 * @hidden
 */


export function measureColumnDepth(column) {
  var max = 0;

  for (var i = 0; i < column.length; i++) {
    var depth = checkDepth(column[i], 0);

    if (max < depth) {
      max = depth;
    }
  }

  return max + 1;
}
/**
 * @hidden
 */

export function checkDepth(col, index) {
  var max = index;
  var indices = [];

  if (col.columns) {
    index++;

    for (var i = 0; i < col.columns.length; i++) {
      indices[i] = checkDepth(col.columns[i], index);
    }

    for (var j = 0; j < indices.length; j++) {
      if (max < indices[j]) {
        max = indices[j];
      }
    }

    index = max;
  }

  return index;
}
/**
 * @hidden
 */

export function refreshFilteredColsUid(gObj, filteredCols) {
  for (var i = 0; i < filteredCols.length; i++) {
    filteredCols[i].uid = filteredCols[i].isForeignKey ? getColumnByForeignKeyValue(filteredCols[i].field, gObj.getForeignKeyColumns()).uid : gObj.getColumnByField(filteredCols[i].field).uid;
  }
}
/** @hidden */

export var Global;

(function (Global) {
  Global.timer = null;
})(Global || (Global = {}));
/**
 * @hidden
 */


export function getTransformValues(element) {
  var style = document.defaultView.getComputedStyle(element, null);
  var transformV = style.getPropertyValue('transform');
  var replacedTv = transformV.replace(/,/g, '');
  var translateX = parseFloat(replacedTv.split(' ')[4]);
  var translateY = parseFloat(replacedTv.split(' ')[5]);
  return {
    width: translateX,
    height: translateY
  };
}
/** @hidden */

export function applyBiggerTheme(rootElement, element) {
  if (rootElement.classList.contains('e-bigger')) {
    element.classList.add('e-bigger');
  }
}
/** @hidden */

export function alignFrozenEditForm(mTD, fTD) {
  if (mTD && fTD) {
    var mHeight = closest(mTD, '.' + literals.row).getBoundingClientRect().height;
    var fHeight = closest(fTD, '.' + literals.row).getBoundingClientRect().height;

    if (mHeight > fHeight) {
      fTD.style.height = mHeight + 'px';
    } else {
      mTD.style.height = fHeight + 'px';
    }
  }
}
/** @hidden */

export function ensureLastRow(row, gridObj) {
  var cntOffset = gridObj.getContent().firstElementChild.offsetHeight;
  return row && row.getBoundingClientRect().top > cntOffset;
}
/** @hidden */

export function ensureFirstRow(row, rowTop) {
  return row && row.getBoundingClientRect().top < rowTop;
}
/** @hidden */

export function isRowEnteredInGrid(index, gObj) {
  var rowHeight = gObj.getRowHeight();
  var startIndex = gObj.getContent().firstElementChild.scrollTop / rowHeight;
  var endIndex = startIndex + gObj.getContent().firstElementChild.offsetHeight / rowHeight;
  return index < endIndex && index > startIndex;
}
/** @hidden */

export function getEditedDataIndex(gObj, data) {
  var keyField = gObj.getPrimaryKeyFieldNames()[0];
  var dataIndex;
  gObj.getCurrentViewRecords().filter(function (e, index) {
    if (e[keyField] === data[keyField]) {
      dataIndex = index;
    }
  });
  return dataIndex;
}
/** @hidden */

export function eventPromise(args, query) {
  var state;
  state = getStateEventArgument(query);
  var def = new Deferred();
  state.dataSource = def.resolve;
  state.action = args;
  return {
    state: state,
    deffered: def
  };
}
/** @hidden */

export function getStateEventArgument(query) {
  var adaptr = new UrlAdaptor();
  var dm = new DataManager({
    url: '',
    adaptor: new UrlAdaptor()
  });
  var state = adaptr.processQuery(dm, query);
  var data = JSON.parse(state.data);
  return data;
}
/** @hidden */

export function ispercentageWidth(gObj) {
  var columns = gObj.getVisibleColumns();
  var percentageCol = 0;
  var undefinedWidthCol = 0;

  for (var i = 0; i < columns.length; i++) {
    if (isUndefined(columns[i].width)) {
      undefinedWidthCol++;
    } else if (columns[i].width.toString().indexOf('%') !== -1) {
      percentageCol++;
    }
  }

  return (gObj.width === 'auto' || typeof gObj.width === 'string' && gObj.width.indexOf('%') !== -1) && Browser.info.name !== 'chrome' && !gObj.groupSettings.showGroupedColumn && gObj.groupSettings.columns.length && percentageCol && !undefinedWidthCol;
}
/** @hidden */

export function resetRowIndex(gObj, rows, rowElms, index) {
  var startIndex = index ? index : 0;

  for (var i = 0; i < rows.length; i++) {
    if (rows[i].isDataRow) {
      rows[i].index = startIndex;
      rows[i].isAltRow = gObj.enableAltRow ? startIndex % 2 !== 0 : false;
      rowElms[i].setAttribute(literals.ariaRowIndex, startIndex.toString());
      rows[i].isAltRow ? rowElms[i].classList.add('e-altrow') : rowElms[i].classList.remove('e-altrow');

      for (var j = 0; j < rowElms[i].cells.length; j++) {
        rowElms[i].cells[j].setAttribute('index', startIndex.toString());
      }

      startIndex++;
    }
  }

  if (!rows.length) {
    gObj.renderModule.emptyRow(true);
  }
}
/** @hidden */

export function resetRowObjectIndex(gObj, rows, index) {
  var startIndex = index ? index : 0;

  for (var i = 0; i < rows.length; i++) {
    rows[i].index = startIndex;
    startIndex++;
  }
}
/** @hidden */

export function compareChanges(gObj, changes, type, keyField) {
  var newArray = gObj.dataToBeUpdated[type].concat(changes[type]).reduce(function (r, o) {
    r[o[keyField]] = r[o[keyField]] === undefined ? o : Object.assign(r[o[keyField]], o);
    return r;
  }, {});
  gObj.dataToBeUpdated[type] = Object.keys(newArray).map(function (k) {
    return newArray[k];
  });
}
/** @hidden */

export function setRowElements(gObj) {
  if (gObj.isFrozenGrid()) {
    gObj.contentModule.rowElements = [].slice.call(gObj.element.querySelectorAll('.e-movableheader .e-row, .e-movablecontent .e-row'));
    var cls = gObj.getFrozenMode() === literals.leftRight ? '.e-frozen-left-header .e-row, .e-frozen-left-content .e-row' : '.e-frozenheader .e-row, .e-frozencontent .e-row';
    gObj.contentModule.freezeRowElements = [].slice.call(gObj.element.querySelectorAll(cls));

    if (gObj.getFrozenMode() === literals.leftRight) {
      gObj.contentModule.frozenRightRowElements = [].slice.call(gObj.element.querySelectorAll('.e-frozen-right-header .e-row, .e-frozen-right-content .e-row'));
    }
  } else {
    gObj.contentModule.rowElements = [].slice.call(gObj.element.querySelectorAll('.e-row:not(.e-addedrow)'));
  }
}
/** @hidden */

export function splitFrozenRowObjectCells(gObj, cells, tableName) {
  var left = gObj.getFrozenLeftCount();
  var movable = gObj.getMovableColumnsCount();
  var right = gObj.getFrozenRightColumnsCount();
  var frozenMode = gObj.getFrozenMode();
  var drag = gObj.isRowDragable() ? 1 : 0;
  var rightIndex = frozenMode === 'Right' ? left + movable : left + movable + drag;
  var mvblIndex = frozenMode === 'Right' ? left : left + drag;
  var mvblEndIdx = frozenMode === 'Right' ? cells.length - right - drag : right ? cells.length - right : cells.length;

  if (tableName === literals.frozenLeft) {
    cells = cells.slice(0, left ? left + drag : cells.length);
  } else if (tableName === literals.frozenRight) {
    cells = cells.slice(rightIndex, cells.length);
  } else if (tableName === 'movable') {
    cells = cells.slice(mvblIndex, mvblEndIdx);
  }

  return cells;
}
/** @hidden */

export function gridActionHandler(gObj, callBack, rows, force, rowObj) {
  if (rows[0].length || force) {
    rowObj ? callBack(literals.frozenLeft, rows[0], rowObj[0]) : callBack(literals.frozenLeft, rows[0]);
  }

  if (gObj.isFrozenGrid() && (rows[1].length || force)) {
    rowObj ? callBack('movable', rows[1], rowObj[1]) : callBack('movable', rows[1]);
  }

  if ((gObj.getFrozenMode() === literals.leftRight || gObj.getFrozenMode() === 'Right') && (rows[2].length || force)) {
    rowObj ? callBack(literals.frozenRight, rows[2], rowObj[2]) : callBack(literals.frozenRight, rows[2]);
  }
}
/** @hidden */

export function getGridRowObjects(gObj) {
  return [gObj.getFrozenMode() !== 'Right' ? gObj.getRowsObject() : [], gObj.getMovableRowsObject(), gObj.getFrozenRightRowsObject()];
}
/** @hidden */

export function getGridRowElements(gObj) {
  return [gObj.getFrozenMode() !== 'Right' ? gObj.getAllDataRows(true) : [], gObj.getAllMovableDataRows(true), gObj.getAllFrozenRightDataRows(true)];
}
/** @hidden */

export function sliceElements(row, start, end) {
  var cells = row.children;
  var len = cells.length;
  var k = 0;

  for (var i = 0; i < len; i++, k++) {
    if (i >= start && i < end) {
      continue;
    }

    row.removeChild(row.children[k]);
    k--;
  }
}
/** @hidden */

export function getCellsByTableName(gObj, col, rowIndex) {
  if (col.getFreezeTableName() === 'movable') {
    return [].slice.call(gObj.getMovableDataRows()[rowIndex].getElementsByClassName(literals.rowCell));
  } else if (col.getFreezeTableName() === literals.frozenRight) {
    return [].slice.call(gObj.getFrozenRightDataRows()[rowIndex].getElementsByClassName(literals.rowCell));
  } else {
    return [].slice.call(gObj.getDataRows()[rowIndex].getElementsByClassName(literals.rowCell));
  }
}
/** @hidden */

export function getCellByColAndRowIndex(gObj, col, rowIndex, index) {
  var left = gObj.getFrozenLeftCount();
  var movable = gObj.getMovableColumnsCount();
  index = col.getFreezeTableName() === 'movable' ? index - left : col.getFreezeTableName() === literals.frozenRight ? index - (left + movable) : index;
  return getCellsByTableName(gObj, col, rowIndex)[index];
}
/** @hidden */

export function setValidationRuels(col, index, rules, mRules, frRules, len) {
  if (col.getFreezeTableName() === literals.frozenLeft || !index && col.getFreezeTableName() === literals.frozenRight || len === 1) {
    rules[getComplexFieldID(col.field)] = col.validationRules;
  } else if (col.getFreezeTableName() === 'movable' || !col.getFreezeTableName()) {
    mRules[getComplexFieldID(col.field)] = col.validationRules;
  } else if (col.getFreezeTableName() === literals.frozenRight) {
    frRules[getComplexFieldID(col.field)] = col.validationRules;
  }
}
/** @hidden */

export function getMovableTbody(gObj) {
  var tbody;

  if (gObj.isFrozenGrid()) {
    tbody = gObj.frozenRows && gObj.editSettings.newRowPosition === 'Top' ? gObj.getMovableHeaderTbody() : gObj.getMovableContentTbody();
  }

  return tbody;
}
/** @hidden */

export function getFrozenRightTbody(gObj) {
  var tbody;

  if (gObj.getFrozenMode() === literals.leftRight) {
    tbody = gObj.frozenRows && gObj.editSettings.newRowPosition === 'Top' ? gObj.getFrozenRightHeaderTbody() : gObj.getFrozenRightContentTbody();
  }

  return tbody;
}
export function setRowsInTbody(tbody, mTbody, frTbody, tr, mTr, frTr, callBack) {
  if (tbody && tr) {
    callBack(tbody, tr);
  }

  if (mTbody && mTr) {
    callBack(mTbody, mTr);
  }

  if (frTbody && frTr) {
    callBack(frTbody, frTr);
  }
}
/** @hidden */

export function getNumberFormat(numberFormat, type, isExcel) {
  var format;
  var intl = new Internationalization();

  if (type === 'number') {
    try {
      format = intl.getNumberPattern({
        format: numberFormat,
        currency: this.currency,
        useGrouping: true
      }, true);
    } catch (error) {
      format = numberFormat;
    }
  } else if (type === 'date' || type === 'time' || type === 'datetime') {
    try {
      format = intl.getDatePattern({
        skeleton: numberFormat,
        type: type
      }, isExcel);

      if (isNullOrUndefined(format)) {
        throw 'error';
      }
    } catch (error) {
      try {
        format = intl.getDatePattern({
          format: numberFormat,
          type: type
        }, isExcel);
      } catch (error) {
        format = numberFormat;
      }
    }
  } else {
    format = numberFormat;
  }

  if (type !== 'number') {
    var patternRegex = /G|H|c|'| a|yy|y|EEEE|E/g;
    var mtch_1 = {
      'G': '',
      'H': 'h',
      'c': 'd',
      '\'': '"',
      ' a': ' AM/PM',
      'yy': 'yy',
      'y': 'yyyy',
      'EEEE': 'dddd',
      'E': 'ddd'
    };
    format = format.replace(patternRegex, function (pattern) {
      return mtch_1[pattern];
    });
  }

  return format;
}
/** @hidden */

export function addBiggerDialog(gObj) {
  if (gObj.enableAdaptiveUI) {
    var dialogs = document.getElementsByClassName('e-responsive-dialog');

    for (var i = 0; i < dialogs.length; i++) {
      dialogs[i].classList.add('e-bigger');
    }
  }
}
/** @hidden */

export function performComplexDataOperation(value, mapObject) {
  var returnObj;
  var length = value.split('.').length;
  var splits = value.split('.');
  var duplicateMap = mapObject;

  for (var i = 0; i < length; i++) {
    returnObj = duplicateMap[splits[i]];
    duplicateMap = returnObj;
  }

  return returnObj;
}
/** @hidden */

export function setDisplayValue(tr, idx, displayVal, rows, parent, isContent) {
  var trs = Object.keys(tr);

  for (var i = 0; i < trs.length; i++) {
    var td = tr[trs[i]].querySelectorAll('td.e-rowcell')[idx];

    if (tr[trs[i]].querySelectorAll('td.e-rowcell').length && td) {
      setStyleAttribute(tr[trs[i]].querySelectorAll('td.e-rowcell')[idx], {
        'display': displayVal
      });

      if (tr[trs[i]].querySelectorAll('td.e-rowcell')[idx].classList.contains('e-hide')) {
        removeClass([tr[trs[i]].querySelectorAll('td.e-rowcell')[idx]], ['e-hide']);
      }

      if (isContent && parent.isRowDragable()) {
        var index = parent.getFrozenColumns() ? idx : idx + 1;
        rows[trs[i]].cells[index].visible = displayVal === '' ? true : false;
      } else {
        rows[trs[i]].cells[idx].visible = displayVal === '' ? true : false;
      }
    }
  }
}
/** @hidden */

export function addRemoveEventListener(parent, evt, isOn, module) {
  for (var _i = 0, evt_1 = evt; _i < evt_1.length; _i++) {
    var inst = evt_1[_i];
    isOn ? parent.on(inst.event, inst.handler, module) : parent.off(inst.event, inst.handler);
  }
}
/** @hidden */

export function createEditElement(parent, column, classNames, attr) {
  /* tslint:disable-next-line:no-any */
  var complexFieldName = getComplexFieldID(column.field);
  attr = Object.assign(attr, {
    id: parent.element.id + complexFieldName,
    name: complexFieldName,
    'e-mappinguid': column.uid
  });
  return parent.createElement('input', {
    className: classNames,
    attrs: attr
  });
}